function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as r } from "./index.es33.js";
import { useState as p, useEffect as I } from "react";
import { t as V } from "./index.es106.js";
import "./index.es133.js";
import "react-dom";
import { isEmpty as n } from "./index.es159.js";
import "./index.es134.js";
import { Typography as c } from "./index.es35.js";
import "./index.es36.js";
import { Select as d } from "./index.es17.js";
import { SearchableControl as E } from "./index.es438.js";
import { OptionWrapper as R } from "./index.es444.js";
import { OptionItem as T } from "./index.es445.js";
import { DropdownWithVirtualScroll as W } from "./index.es446.js";
import f from "./index.es447.js";
var _ = function _(_ref) {
  var h = _ref.options,
    t = _ref.value,
    x = _ref.label,
    S = _ref.placeholder,
    b = _ref.isSearchable,
    u = _ref.isClearable,
    j = _ref.isDisabled,
    y = _ref.isError,
    O = _ref.hint,
    C = _ref.kind,
    D = _ref.onSelect,
    g = _ref.onChangeSearch,
    _ref$isTruncated = _ref.isTruncated,
    l = _ref$isTruncated === void 0 ? !1 : _ref$isTruncated,
    L = _ref.isLoading,
    v = _ref.noOptionsMessage,
    s = _ref.forcedOpen;
  var _p = p(""),
    _p2 = _slicedToArray(_p, 2),
    i = _p2[0],
    a = _p2[1],
    _ref2 = s || p(!1),
    _ref3 = _slicedToArray(_ref2, 2),
    o = _ref3[0],
    w = _ref3[1],
    m = h.filter(function (e) {
      return String(e.label).toLocaleLowerCase().indexOf(i.toLocaleLowerCase()) >= 0;
    });
  return I(function () {
    o || a("");
  }, [o]), r.jsxs(d, {
    onOptionClick: function onOptionClick(e) {
      return !Array.isArray(e) && e && (D === null || D === void 0 ? void 0 : D(e));
    },
    onChangeOpenState: w,
    label: x,
    kind: C,
    isClearable: u,
    isDisabled: j,
    isError: y,
    hint: O,
    isTruncated: l,
    isLoading: L,
    forcedOpen: s,
    placeholder: r.jsx(E, {
      isSearchable: b,
      onChangeSearch: function onChangeSearch(e) {
        a(e), g === null || g === void 0 ? void 0 : g(e);
      },
      isOpen: o,
      searchValue: i,
      placeholder: n(t === null || t === void 0 ? void 0 : t.label) ? S : t === null || t === void 0 ? void 0 : t.label,
      isPale: n(t === null || t === void 0 ? void 0 : t.value),
      isTruncated: l
    }),
    value: t,
    children: [!m.length && r.jsx(c.Body2, {
      className: f.noItems,
      children: v || V("component_searchItemMenu_noSearchResults_noResultsLabel")
    }), m.map(function (e) {
      return r.jsx(d.Option, {
        isSelected: e.value === (t === null || t === void 0 ? void 0 : t.value),
        value: e,
        isDisabled: e.disabled,
        isTruncated: l,
        isDivided: e.isDivided,
        children: r.jsx(c.Body2, {
          className: f.optionContainer,
          as: "div",
          children: r.jsx(R, {
            isDisabled: e.disabled,
            disabledTooltipText: e.disabledTooltipText,
            children: r.jsx(T, {
              option: e
            })
          })
        })
      }, e.value);
    })]
  });
};
_.WithVirtualScroll = W;
export { _ as SelectDropDown };